import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, BriefcaseIcon, MonitorIcon, HeartPulseIcon, ShieldCheckIcon, BrainIcon, BookOpenIcon, SettingsIcon, LibraryIcon } from 'lucide-react';
import { DegreeCategory } from '../data/degrees';
const iconMap: Record<string, React.ElementType> = {
  BriefcaseIcon,
  MonitorIcon,
  HeartPulseIcon,
  ShieldCheckIcon,
  BrainIcon,
  BookOpenIcon,
  SettingsIcon,
  LibraryIcon
};
interface DegreeCardProps {
  category: DegreeCategory;
}
export function DegreeCard({
  category
}: DegreeCardProps) {
  const IconComponent = iconMap[category.icon] || BookOpenIcon;
  return <Link to={`/degrees/${category.id}`} className="group flex h-full flex-col justify-start bg-surface rounded-2xl border border-hairline p-6 shadow-ds transition-[box-shadow,transform] duration-200 ease-out hover:-translate-y-0.5 hover:shadow-ds-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-136" data-mp="179l9d1nup2d9">
      <div className="flex items-start justify-between gap-3 mb-5" data-id="element-137" data-mp="1ucdgvv7or4vu">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-background-alt text-primary transition-colors duration-200 group-hover:bg-primary group-hover:text-white" data-id="element-138" data-mp="1ua0pysjy9k6n">
          <IconComponent className="w-6 h-6" data-id="element-139" data-mp="23ap2fitp3chf" />
        </span>
        <span className="inline-flex items-center rounded-full bg-[#EDF7E7] px-2.5 py-0.5 text-xs font-semibold leading-5 text-[#3F7F22] ring-1 ring-inset ring-[#C9E6B8] whitespace-nowrap" data-id="element-140" data-mp="284jtx8fjkvr2">
          {category.programCount}+ Programs
        </span>
      </div>

      <h3 className="text-lg font-bold leading-snug text-ink mb-2" data-id="element-141" data-mp="2n0squ3bymx0b">
        {category.name}
      </h3>

      <p className="text-sm leading-relaxed text-ink-secondary mb-5 flex-grow" data-id="element-142" data-mp="2r24a7r48qm02">
        {category.description}
      </p>

      <div className="flex items-center text-sm font-semibold text-primary mt-auto" data-id="element-143" data-mp="snjgk9blb7h0">
        Explore Degrees
        <ChevronRightIcon className="w-4 h-4 ml-1 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-144" data-mp="wpeed3ubb2q1" />
      </div>
    </Link>;
}